import React, { useState } from "react"
import { Controller } from "react-hook-form"
import PhoneInput, {
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input"
import * as style from "./input.module.css"
import "react-phone-number-input/style.css"

const PhoneInputFormItem = ({
  CustomClass,
  name,
  control,
  errors,
  defaultCountry = "IN",
  phoneRequired = false,
  selectClassName = "",
}) => {
  const CustomCountrySelect = ({ value, onChange }) => {
    const [showAll, setShowAll] = useState(false);

    const countries = getCountries() // Get available countries
    const defaultCountries = ["US", "GB", "IN", "CA", "AU"];
    const displayedCountries = showAll ? countries : defaultCountries;

    return (
      <select
        value={value}
        onFocus={() => setShowAll(true)} // Show all countries only when focused
        onChange={e => onChange(e.target.value)}
        className={`${style.customDropdown} ${selectClassName}`}
      >
        {displayedCountries.map(country => (
          <option key={country} value={country}>
            +{getCountryCallingCode(country)}
          </option>
        ))}
      </select>
    )
  }
  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{
          required: phoneRequired,
          validate: value =>
            isValidPhoneNumber(value) || "Enter a valid number!",
        }}
        render={({ field: { onChange, value } }) => (
          <PhoneInput
            value={value}
            onChange={onChange}
            countryCallingCodeEditable={false}
            limitMaxLength={true}
            international={false}
            defaultCountry={defaultCountry}
            withCountryCallingCode={true}
            className={`${CustomClass}`}
            countrySelectComponent={CustomCountrySelect}
            placeholder="Phone Number"
          />
        )}
      />
      {errors[name] && (
        <span
          style={{
            color: "#e95444",
            marginTop: "10px",
            display: "inline-block",
          }}
        >
          {errors[name]?.message || "Phone Number is Required!"}
        </span>
      )}
    </>
  )
}

export default PhoneInputFormItem
